export const SET_ROLE = 'SET_ROLE';
export const SET_USERS = 'SET_USERS';
